import { DriverWorkYearsPeriods } from 'app/constants/configuration/driverWorkYearsPeriods'

export const getDriverWorkYearsPeriodsWorkName = (
  driverWorkYearsPeriods: DriverWorkYearsPeriods,
  translate: (string) => string,
): string => {
  const text: string = DriverWorkYearsPeriods[driverWorkYearsPeriods]
  return translate(`driverWorkYearsPeriods.${text}`)
}
